import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepOneITE from "./Step2/StepOneITE";
import StepTwoITE from "./Step2/StepTwoITE";
import StepFourITE from "./Step2/StepFourITE";
import StepFiveITE from "./Step2/StepFiveITE";
import StepSixITE from "./Step2/StepSixITE";
import StepSevenITE from "./Step2/StepSevenITE";

const MultiStepForm2ITE = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0); // Commence avec l'étape préliminaire à l'index 0

  const handleNext = () => {
    if (currentStep === 5) {
      navigate("/client-economies-ite"); // Naviguez après la dernière étape
    } else {
      setCurrentStep((prev) => prev + 1); // Avance à l'étape suivante
    }
  };

  const handleBack = () => {
    if (currentStep === 0) {
      navigate("/client-info-ite"); // Rediriger vers "/client-info" lorsque vous êtes à la première étape
    } else if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1); // Retour à l'étape précédente si pas la première
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <StepOneITE onNext={handleNext} onBack={handleBack} />;
      case 1:
        return <StepTwoITE onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <StepFourITE onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <StepFiveITE onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <StepSixITE onNext={handleNext} onBack={handleBack} />;
      case 5:
        return <StepSevenITE onNext={handleNext} onBack={handleBack} />;
      default:
        return <div>Étape inconnue</div>;
    }
  };

  return <div>{renderStep()}</div>;
};

export default MultiStepForm2ITE;
